import React from "react";
import "../../assest/css/footer.css";
import { socialLinks } from "../../constant/constants";

export default function SocialLinks() {
  const { facebook, twitter, linkedin, youtube, github } = socialLinks;
  return (
    <div className="social">
      <a href={twitter}>
        <i className="icon ion-social-twitter"></i>
      </a>
      <a href={facebook}>
        <i className="icon ion-social-facebook"></i>
      </a>
      <a href={youtube}>
        <i className="icon ion-social-youtube"></i>
      </a>
      <a href={linkedin}>
        <i className="icon ion-social-linkedin"></i>
      </a>
      <a href={github}>
        <i className="icon ion-social-github"></i>
      </a>
    </div>
  );
}
